var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { theme } from '../../theme';
import { Option } from '../Option';
export var SelectAllOption = styled(Option)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-bottom: solid 1px ", ";\n  font-weight: 600;\n"], ["\n  border-bottom: solid 1px ", ";\n  font-weight: 600;\n"])), theme.color('background'));
var templateObject_1;
//# sourceMappingURL=Options.style.js.map